import {hookToAttributeSelector} from '@wix/panda-js-utils'
import {membersPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {isMobile} from '../../../../../../commons/selectors/environment'
import {useMembersPageActions, useMembersPageSelector} from '../../../hooks/runtime'
import {EventLink} from '../../styled-components/event-link'
import {ShareButtonProps} from './interfaces'

export const ShareButton = ({event}: ShareButtonProps) => {
  const {t} = useTranslation()

  const mobile = useMembersPageSelector(isMobile)
  const {shareEvent} = useMembersPageActions()

  return (
    <EventLink
      mobile={mobile}
      onClick={() => shareEvent({event, returnFocusElement: hookToAttributeSelector(DH.BUTTON_SHARE)})}
      data-hook={DH.BUTTON_SHARE}
      textButton
    >
      {t('events.buttons.share-event')}
    </EventLink>
  )
}
